import { Position } from "../../api";

interface Props {
  positions: Position[];
  bridgeConnected: boolean;
}

function fmtPrice(v: number): string {
  if (!Number.isFinite(v)) return "—";
  // Forex-friendly: 5 dp for sub-1 prices, 3 dp for JPY pairs, 4 otherwise.
  const abs = Math.abs(v);
  const dp = abs < 1 ? 5 : abs < 100 ? 4 : 3;
  return v.toFixed(dp);
}

function fmtPnl(v: number): string {
  return `${v >= 0 ? "+" : ""}${v.toFixed(2)}`;
}

export function PositionsCompact({ positions, bridgeConnected }: Props) {
  return (
    <section className="flex h-full flex-col rounded-xl border border-border bg-surface">
      <header className="flex items-baseline justify-between border-b border-border px-5 py-3">
        <h3 className="text-[11px] font-medium uppercase tracking-[0.15em] text-fg-muted">
          Open positions
        </h3>
        <span className="font-mono text-xs text-fg-muted">
          {positions.length} open
        </span>
      </header>

      <div className="min-h-0 flex-1 overflow-y-auto">
        {!bridgeConnected ? (
          <p className="p-5 text-sm text-fg-muted">
            bridge offline — cannot fetch positions
          </p>
        ) : positions.length === 0 ? (
          <p className="p-5 text-sm text-fg-muted">no open positions</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-wider text-fg-muted">
              <tr>
                <th className="px-5 py-2 text-left font-medium">Symbol</th>
                <th className="px-2 py-2 text-left font-medium">Side</th>
                <th className="px-2 py-2 text-right font-medium">Lot</th>
                <th className="px-2 py-2 text-right font-medium">Entry</th>
                <th className="px-5 py-2 text-right font-medium">P/L</th>
              </tr>
            </thead>
            <tbody>
              {positions.map((p) => {
                const pnl = p.profit + (p.swap || 0);
                return (
                  <tr
                    key={p.ticket}
                    className="border-t border-border/60 transition-colors hover:bg-bg-hover/50"
                  >
                    <td className="px-5 py-2 font-mono text-sm font-semibold">
                      {p.symbol}
                    </td>
                    <td className="px-2 py-2">
                      <span
                        className={`rounded px-1.5 py-0.5 text-[10px] font-bold uppercase ${
                          p.side === "buy"
                            ? "bg-success/15 text-success"
                            : "bg-danger/15 text-danger"
                        }`}
                      >
                        {p.side}
                      </span>
                    </td>
                    <td className="px-2 py-2 text-right font-mono tabular-nums">
                      {p.volume.toFixed(2)}
                    </td>
                    <td className="px-2 py-2 text-right font-mono tabular-nums text-fg-muted">
                      {fmtPrice(p.price_open)}
                    </td>
                    <td
                      className={`px-5 py-2 text-right font-mono font-semibold tabular-nums ${
                        pnl > 0 ? "text-success" : pnl < 0 ? "text-danger" : ""
                      }`}
                    >
                      {fmtPnl(pnl)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
}
